import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import { compose } from 'redux';
import { connect } from 'react-redux';
import updateAction from './updateAction';
import Loader from '../../utils/Loader';
import { addOnboardDetails } from '../../redux/profile/profile.actions';
import Card from 'react-bootstrap/Card';
import { FullNameRegex } from '../../utils/regex';


const Step5 = ({ history, phone, full_name, addOnboardDetails }) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const { state, action } = useStateMachine(updateAction);
	const [showWhatsAppInput, setShowWhatsAppInput] = useState(true);

	const onSubmit = async (data) => {
		if (!data.fullname) {
			data['fullname'] = full_name;
		}
		action(data);
		history.push('./step2');
	};


	useEffect(() => {
		const textbox = document.getElementById('step1-name')
		textbox.focus()
		console.log("textbox ", textbox)
	}, []);

	Loader.hide();

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="step-form">
			<div className="form-group" style={{ marginTop: '10px' }}>
				<label className="control-label" htmlFor="fullname">Let's start with your <strong>name</strong></label>
				<input
					type="text"
					className="form-control"
					name="fullname"
					ref={register({
						pattern: FullNameRegex,
						required: true,
					})}
					defaultValue={state.data?.fullname}
					id="step1-name"
				/>
				<span className="profileError">
					{errors.fullname?.type === 'pattern' && 'Incorrect name.'}
					{errors.fullname?.type === 'required' && 'Name is required.'}
				</span>
			</div>

			<input
				type="hidden"
				name="isParent"
				value={0}
				ref={register({
					required: true,
				})}
			/>
			{/* <span className="profileError">
				{errors.receiveWhatsappNotification?.type === 'required' &&
					'Whatsapp Notification is required'}
			</span> */}
			<label htmlFor="receiveWhatsappNotification" className="receiveUpdates">
				<input
					type="checkbox"
					name="receiveWhatsappNotification"
					id="receiveUpdates"
					defaultChecked={true}
					onChange={(e) => setShowWhatsAppInput(e.target.checked)}
					ref={register({
						required: false,
					})}
				/>
				Receive offers and updates on WhatsApp
			</label>


			{showWhatsAppInput && (
				<div className="form-group">
					<label htmlFor="whatsappNumber">WhatsApp Number</label>
					<input
						type="text"
						className="form-control"
						name="whatsappNumber"
						ref={register({
							required: true,
							pattern: /^[6789]\d{9}$/,
						})}
						defaultValue={state.data?.whatsappNumber || phone}
					/>
					<span className="profileError">
						{errors.whatsappNumber?.type === 'required' && 'WhatsApp number is required.'}
					</span>
					<span className="profileError">
						{errors.whatsappNumber?.type === 'pattern' && 'Incorrect mobile number'}
					</span>
				</div>
			)}


			<button
				aria-label="next"
				className="btn btn-primary btn-md"
				type="submit"
			>Next</button>
		</form>
	);
};

const mapStateToProps = (state) => {
	const { full_name } = state.rootReducer.userDetails;
	return {
		full_name,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj)),
	};
};



export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Step5);